import * as R from 'ramda';
import React, { useCallback, useEffect, useState } from 'react';
// helpers/constants
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
//////////////////////////////////////////////////

const useInitialData = (props) => {
  const {
    showMsg,
    closeModal,
    openLoader,
    showDimmer,
    closeLoader,
    asyncMethod,
    asyncOptions,
    asyncEndpoint,
    asyncShouldCloseModal,
  } = props;

  const [asyncInitialData, setAsyncInitialData] = useState({ data: null, error: false, loading: true });

  const setLoading = useCallback(() => {
    setAsyncInitialData((prev) => R.assoc('loading', true, prev));
  }, []);

  const getInitialDataRequest = useCallback(async (endpoint, requestOptions) => {
    if (G.isFunction(openLoader)) {
      openLoader({ showDimmer: G.ifElse(G.isNotNilAndNotEmpty(showDimmer), showDimmer, true)});
    }
    const options = R.or(requestOptions, asyncOptions);

    const res = await sendRequest(R.or(asyncMethod, 'get'), R.or(endpoint, asyncEndpoint), options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      if (G.isNotNil(data)) {
        setAsyncInitialData((prev) => ({
          ...prev,
          data,
          loading: false,
          dataUniqId: G.generateGuid2(),
        }));
      }
    } else {
      G.handleFailResponseSimple(
        res,
        R.or(showMsg, false),
        'withAsyncInitialData -> getInitialDataRequest',
      );
    }

    if (G.isFunction(closeLoader)) closeLoader();

    if (R.and(G.isTrue(asyncShouldCloseModal), G.isFunction(closeModal))) closeModal();
  }, [asyncMethod, asyncOptions, asyncEndpoint]);

  return { setLoading, asyncInitialData, getInitialDataRequest };
};

const withAsyncInitialData = (Component) => (props) => {
  const initialData = useInitialData(props);

  return <Component {...props} {...initialData} />;
};

const withAsyncInitialDataOnDidMount = (Component) => (props) => {
  const initialData = useInitialData(props);

  const { getInitialDataRequest } = initialData;

  useEffect(() => {
    getInitialDataRequest();
  }, []);

  return <Component {...props} {...initialData} />;
};

export {
  withAsyncInitialData,
  withAsyncInitialDataOnDidMount,
};
